
import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Api from "services/api"
import toast from "react-hot-toast";
import { ListLayout } from "components/common/ListLayout";
import TableHeaderItem from "components/common/ListLayout/TableHeaderItem";
import { userSelector } from "slices/userSlice";
import { usePermissions } from "layouts/Admin";
import { Controller, useForm } from "react-hook-form";
import moment from "moment";
import { SubmitButton } from "components/common/buttons/SubmitButton";
import { paymentSelector } from "slices/paymentSlice";
import ConfirmationStatus from "components/common/ConfirmationMessageStatus";
import { handleMultipleStatus } from "slices/paymentSlice";
import { fetchInterpreterPayments } from "slices/paymentSlice";
import { fetchInterpreters } from "slices/interpreterSlice";
import { AsyncPaginate } from "react-select-async-paginate";
import { selectCustomStyles } from "components/common/Select";
import ErrorMessage from "components/common/ErrorMessage";
const apiService = new Api();

function IntepreterPayments() {
    const dispatch = useDispatch()
    const { checkPermission } = usePermissions();
    const { interpreterPayment: payment, generatedInvoices, last_page: totalPages, loader, total, current_page, per_page: pageLength } = useSelector(paymentSelector);

    const [statusModal, setStatusModal] = React.useState(false);

    const refAddutton = React.useRef(null);
    const [selectedItems, setSelectedItems] = React.useState([]);
    const [selectAll, setSelectAll] = React.useState(false);
    const [currentPage, setCurrentPage] = React.useState(1);
    const [searchTerm, setSearchTerm] = React.useState("");
    const [sortConfig, setSortConfig] = React.useState({
        sortBy: 'name',
        sortDirection: 'asc',
    });
    const { user } = useSelector(userSelector);
    const userToken = user.token;

    React.useEffect(() => {
        dispatch(fetchInterpreterPayments())
    }, [])

    const submitCallback = (status, message) => {
        if (status) {
            toast.success(message, {
                className: "successToast",
            })
            setSelectedItems([]);
            setSelectAll(false)
            dispatch(fetchInterpreterPayments())
            hideConfirmStatusDialog()
        }
        else {
            toast.error(message,
                {
                    className: "errorToast",
                }
            );
        }
    };


    const hideConfirmStatusDialog = () => {
        setStatusModal(false);
    }
    const showConfirmStatusDialog = () => {
        setStatusModal(true);
        return
    };
    const handleStatusChangeItems = () => {
        dispatch(handleMultipleStatus({ ids: selectedItems }, submitCallback))
    }

    const handleChange = (e) => {
        const id = e.target.dataset.value
        setSelectedItems(
            selectedItems.includes(id) ?
                selectedItems.filter((item) => item != id) :
                [...selectedItems, id]
        )
    };
    const handleToggleSelectAll = () => {
        if (selectAll) {
            setSelectedItems([])
            setSelectAll(false)
            return
        }
        setSelectAll(true)
        setSelectedItems(payment?.map((val) => val.id.toString()))
    }


    //#region TABLE HEAD 

    const renderTableHeader = React.useCallback(() => {
        const callBack = (dir, sortBy) => {
            setSortConfig({ sortBy, sortDirection: dir })
            dispatch(fetchInterpreterPayments(currentPage, { sortBy: sortBy, sortDirection: dir, search: searchTerm }))
        }
        return (
            <tr>
                <th className="col-1">
                    <div className="row_check">
                        <span>#</span>
                        {(checkPermission("Change Interpreter Status") && payment?.find(i => i.status === "pending")) &&
                            <label className="custom-checkbox checkbox"><input type="checkbox" name="select-all" checked={selectAll} onChange={handleToggleSelectAll} /><span className="checkmark"></span></label>
                        }
                    </div>
                </th>
                <th>
                    <TableHeaderItem
                        title="Interpreter"
                        sortBy="interpreter_id"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>
                <th>
                    <TableHeaderItem
                        title="Appointment Number"
                        sortBy="appt_no"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>
                <th>
                    <TableHeaderItem
                        title="Payment"
                        sortBy="payment"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>

                <th>
                    <TableHeaderItem
                        title="Payment Status"
                        sortBy="status"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>

                <th>
                    <TableHeaderItem
                        title="Updated At"
                        sortBy="updated_at"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>

            </tr>
        )
    }, [selectAll, searchTerm, sortConfig, currentPage, selectedItems]);

    //#endregion


    //#region TABLE BODY

    const renderTableContent = React.useCallback(() => {
        return (
            payment?.map((item, index) => (
                <PaymentItems invoice={generatedInvoices} data={item} userToken={userToken} index={index} selectedItems={selectedItems} handleChange={handleChange} current_page={current_page} pageLength={pageLength} checkPermission={checkPermission} />
            ))
        )
    }, [payment, selectedItems]);

    //#endregion


    return (
        <>
            <InvoicePayments />
            <ListLayout
                time={false}
                addButtonDisabled={true}
                renderTableHeader={renderTableHeader}
                renderTableContent={renderTableContent}
                hideRemoveButton={true}
                paymentButton={true}
                totalPages={totalPages}
                fetchList={fetchInterpreterPayments}
                selectedItems={selectedItems}
                refAddutton={refAddutton}
                searchTerm={searchTerm}
                setSearchTerm={setSearchTerm}
                showConfirmDialog={showConfirmStatusDialog}
                loader={loader}
                noOfItems={total}
                containerStyle={{ marginTop: '0' }}
                searchPlaceholder="Search..."
            >
                {statusModal && <ConfirmationStatus onClose={hideConfirmStatusDialog} isOpen={statusModal} onConfirm={handleStatusChangeItems} />}
            </ListLayout>
        </>
    )

}


const PaymentItems = ({
    data, index, current_page, pageLength, handleChange, selectedItems, checkPermission
}) => {
    const serial = useMemo(() => {
        return index + 1 + (current_page - 1) * pageLength;
    }, [current_page, pageLength]);

    return (
        <tr>
            <td>
                <div className="row_check">
                    <span>{serial}</span>
                    {(checkPermission("Change Interpreter Status") && data?.status === "pending") &&
                        <label className="custom-checkbox checkbox">
                            <input type="checkbox" name="select-all" data-value={data.id} checked={selectedItems.includes(data.id.toString())} onChange={handleChange} />
                            <span className="checkmark"></span>
                        </label>
                    }
                </div>
            </td>
            <td>
                {data?.interpreter?.user?.name || 'N/A'}
            </td>
            <td>
                {data?.appointment?.appid || 'N/A'}
            </td>
            <td>
                ${data?.payment_cost || 'N/A'}
            </td>
            <td className="text-capitalize">
                {data?.status || 'N/A'}
            </td>
            <td className="text-capitalize">
                {data?.date || 'N/A'}
            </td>
        </tr>
    )
}


export default IntepreterPayments;





const InvoicePayments = () => {
    const dispatch = useDispatch();
    const [interpreterState, setInterpreterState] = useState([]);
    const startDateRef = React.useRef(null);
    const endDateRef = React.useRef(null);
    const defaultValues = {
        start_date: "",
        end_date: "",
    };
    const { clearErrors, handleSubmit, watch, formState: { errors }, control, setValue, reset, getValues } = useForm({
        defaultValues: defaultValues
    });

    const handleResetFields = () => {
        reset(defaultValues);
        dispatch(fetchInterpreterPayments(1, defaultValues));
    };

    const onSubmit = (data) => {
        dispatch(fetchInterpreterPayments(1, data));
    };

    const filteredInterpreterLoadOptions = async (inputValue, loadedOptions, { page }) => {
        const result = await dispatch(fetchInterpreters(page, { pageLength: 20, sortBy: "id", sortDirection: "asc", search: inputValue }, true, true));

        return {
            options: result.data.map((item) => ({
                value: item.id,
                label: item.user.name,
            })),
            hasMore: page !== result?.last_page,
            additional: { page: page + 1 },
        };
    };

    return (
        <div className="content" style={{ minHeight: 'auto' }}>
            <div className="row_main_head">
                <h2 className={`main_heading`}>Payments</h2>
            </div>
            <div className="card_table">
                <form className="invoicing_form">
                    <div className='row_Invoice'>
                        <div className="row-primary">
                            <h2>From Date</h2>
                            <Controller
                                name="start_date"
                                control={control}
                                render={({ field }) => (
                                    <div className="input-image">
                                        <input ref={startDateRef} id='start_date' type="date" name='start_date' placeholder='Start Date' required
                                            {...field}
                                            value={field.value}
                                            onChange={(e) => field.onChange(moment(new Date(e.target.value)).format("YYYY-MM-DD"))}
                                        />
                                        <img src="/images/celender.png" alt="calendar Icon" className="custom-icon" />
                                    </div>
                                )} />
                        </div>
                        <div className="row-primary">
                            <h2>To Date</h2>
                            <Controller
                                name="end_date"
                                control={control}
                                render={({ field }) => (
                                    <div className="input-image ">
                                        <input ref={endDateRef} type="date" name='end_date' placeholder='End Date' required
                                            {...field}
                                            value={field.value}
                                            onChange={(e) => field.onChange(moment(new Date(e.target.value)).format("YYYY-MM-DD"))}
                                        />
                                        <img src="/images/celender.png" alt="calendar Icon" className="custom-icon" />
                                    </div>
                                )} />
                        </div>
                        <div className="row-primary">
                            <h2>Interpreters</h2>
                            <Controller
                                name="interpreter_ids"
                                control={control}
                                render={({ field }) => (
                                    <div style={{ width: "100%" }}>
                                        <AsyncPaginate
                                            menuPlacement='auto'
                                            isMulti
                                            styles={{
                                                ...selectCustomStyles,
                                            }}
                                            value={interpreterState || []}
                                            loadOptions={filteredInterpreterLoadOptions}
                                            isClearable
                                            escapeClearsValue
                                            onChange={(obj) => {
                                                setInterpreterState(obj);
                                                field.onChange(obj.map((opt) => opt.value));
                                            }}
                                            additional={{
                                                page: 1,
                                            }}
                                        />
                                        {
                                            errors?.client_ids?.message &&
                                            <div style={{ marginBottom: 10 }}>
                                                <ErrorMessage text={errors?.client_ids?.message} />
                                            </div>
                                        }
                                    </div>
                                )}
                            />
                        </div>
                    </div>

                    <div className="row-primary btns_area row_10 mb-0">
                        <SubmitButton handleSubmit={handleSubmit(onSubmit)} btnText="Search" className={'green'} />
                        <SubmitButton buttonType="button" className={'lightBlue'} btnText="Reset" handleSubmit={handleResetFields} />
                    </div>
                </form>
            </div>
        </div>
    );
}